import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const authHeaders = (authToken) => ({
  'Content-Type': 'application/json',
  ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
});

/**
 * Create a Stripe Checkout Session for a credit pack.
 * The caller redirects the browser to the returned checkout_url; credits are
 * added later by the webhook, not by this call.
 * @returns {Promise<{success, data:{checkout_url, session_id, pack_id, credits}}>}
 */
const createCheckoutSession = async (packId, authToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/billing/purchase`,
    { pack_id: packId },
    { headers: authHeaders(authToken) }
  );
  return response.data;
};

/**
 * Pre-scan cost preview for a piece of content.
 * Returns {ready:false, retry_after_seconds} while a video's duration is still
 * being extracted, otherwise {ready:true, credits_required, credits_balance, ...}.
 */
const getScanCost = async (contentId, authToken) => {
  const response = await axios.get(
    `${API_BASE_URL}/api/scan/cost`,
    {
      params: { content_id: contentId },
      headers: authHeaders(authToken),
    }
  );
  return response.data;
};

const billingService = {
  createCheckoutSession,
  getScanCost,
};

export default billingService;
